import Shift from "../../../../components/company/organization/shift";

const ShiftPage: React.FC = () => {
    return (
        <Shift />
    )
};

export default ShiftPage;